export type BookCoverArt = {
  bg: string;
  accent: string;
  ink: string;
  motif: "lanterns" | "menorah" | "rangoli" | "street";
};

export type BookTag = { label: string; cls: "new" | "fav" };

export type Book = {
  id: BookId;
  title: string;
  titleSecond: string;
  titleLines?: [string, string];
  placeholderName: string;
  namePrefix: string;
  series: string;
  tag?: BookTag;
  price: number;
  pages: number;
  age: string;
  cover: BookCoverArt;
  blurb: string;
  dedicationDefault: string;
};

export type BookId = "lunar" | "hanukkah" | "diwali" | "friends";

export const BOOKS: Book[] = [
  {
    id: "lunar",
    title: "Celebrates Chinese New Year",
    titleSecond: "Chinese New Year",
    placeholderName: "Emily",
    namePrefix: "celebrates",
    series: "Festivals of the World — Vol. 01",
    tag: { label: "New", cls: "new" },
    price: 34,
    pages: 32,
    age: "0–7",
    cover: { bg: "#c5392a", accent: "#f3d27a", ink: "#fef6e2", motif: "lanterns" },
    blurb:
      "Step into a sweep of red-and-gold festivity as your little one collects lucky envelopes, helps Grandma make dumplings, and chases lions down the block.",
    dedicationDefault:
      "For my dearest {NAME} — may every new year bring as much luck as the day you came into our lives. With all of my love, always.",
  },
  {
    id: "hanukkah",
    title: "Celebrates Hanukkah",
    titleSecond: "Hanukkah",
    placeholderName: "David",
    namePrefix: "celebrates",
    series: "Festivals of the World — Vol. 02",
    tag: { label: "New", cls: "new" },
    price: 34,
    pages: 32,
    age: "0–7",
    cover: { bg: "#1f3a6b", accent: "#e8b73a", ink: "#f3ecd9", motif: "menorah" },
    blurb:
      "Eight glowing nights, latkes sizzling in the kitchen, and the bright spin of a dreidel — a warm, lamplit story your child stars in from the very first page.",
    dedicationDefault:
      "For my brightest {NAME} — you light up every season of our lives. May this year of miracles be yours. With all of my love.",
  },
  {
    id: "diwali",
    title: "Celebrates Diwali",
    titleSecond: "Diwali",
    placeholderName: "Meghan",
    namePrefix: "celebrates",
    series: "Festivals of the World — Vol. 03",
    tag: { label: "New", cls: "new" },
    price: 34,
    pages: 32,
    age: "0–7",
    cover: { bg: "#7a2a55", accent: "#f3a93a", ink: "#fef0d2", motif: "rangoli" },
    blurb:
      "A festival of lights story where your child draws rangoli on the doorstep, lights diyas with family, and watches the whole neighborhood sparkle to life.",
    dedicationDefault:
      "For my radiant {NAME} — the brightest light in our home. May your year be full of sweetness, sparkle, and love.",
  },
  {
    id: "friends",
    title: "All My Friends Are Beautiful",
    titleSecond: "All My Friends Are Beautiful",
    titleLines: ["All My Friends", "Are Beautiful"],
    placeholderName: "",
    namePrefix: "",
    series: "Hushberry Originals",
    tag: { label: "Staff Pick", cls: "fav" },
    price: 34,
    pages: 36,
    age: "0–7",
    cover: { bg: "#2f5d4a", accent: "#e9c46a", ink: "#f7efdc", motif: "street" },
    blurb:
      "A walk down the block becomes a love letter to the kids next door — each one different, each one beautiful, each one a friend worth knowing.",
    dedicationDefault:
      "For my wonderful {NAME} — may every street you walk be full of new friends, kind hearts, and big adventures. Love always.",
  },
];

export const getBook = (id: string): Book | undefined => BOOKS.find((b) => b.id === id);
